module.exports = __webpack_public_path__ + "media/images/cnbc2-cd8173c529633199a3e0eb5774b8c3ef0947891eaabdc6adf7701d7fc2f008c8.png";